'use client'

import type { Editor } from '@tiptap/react'

import { linkButton } from './editor-toolbar.config'
import { EditorToolbarButton } from './editor-toolbar-button.atom'
import { EditorToolbarColorTools } from './editor-toolbar-color-tools.atom'
import { EditorToolbarDivider } from './editor-toolbar-divider.atom'

export interface EditorToolbarExtrasProps {
  editor: Editor
  isDisabled?: boolean
  isShowLink?: boolean
  isShowColorPicker?: boolean
}

/**
 * Extra toolbar buttons section (link, emoji, color picker, highlight)
 */
export const EditorToolbarExtras = ({
  editor,
  isDisabled = false,
  isShowLink = true,
  isShowColorPicker = true,
}: EditorToolbarExtrasProps) => {
  const hasAnyExtras = isShowLink || isShowColorPicker

  if (!hasAnyExtras) {
    return null
  }

  return (
    <>
      <EditorToolbarDivider />
      {isShowLink && (
        <EditorToolbarButton
          label={linkButton.label}
          shortcut={linkButton.shortcut}
          isActive={linkButton.isActive?.(editor)}
          onClick={() => linkButton.action(editor)}
          disabled={isDisabled}
        >
          <linkButton.icon className="size-4" />
        </EditorToolbarButton>
      )}

      {isShowColorPicker && <EditorToolbarColorTools editor={editor} isDisabled={isDisabled} />}
    </>
  )
}

EditorToolbarExtras.displayName = 'EditorToolbarExtras'
